var map = {
	"./arrows-horizontal.svg": 215,
	"./font/iconfont.svg": 360,
	"./logo-yimian.svg": 28,
	"./logo.svg": 216,
	"./logos/oneview.svg": 361,
	"./logos/wechat.svg": 217,
	"./logos/yidrone.svg": 362,
	"./logos/yimian.svg": 218,
	"./success.svg": 363,
	"./warning.svg": 364
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 398;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.svg$
// module id = 398
// module chunks = 1